import React, { useEffect, useState } from 'react';

interface RotatingTextProps {
  text: string;
  radius: number;
  speed: number;
  count?: number; // Số lượng cụm text
  earthSize?: number;
  textColor?: string; // Màu cho chữ
  direction?: 'clockwise' | 'counterclockwise'; // Hướng quay
  charSpacing?: number; // Khoảng cách giữa các ký tự
  fontSize?: string; // Kích thước chữ
}

const RotatingText: React.FC<RotatingTextProps> = ({
  text,
  radius,
  speed,
  count = 5, // Mặc định hiển thị 5 cụm
  earthSize = 500,
  textColor = 'white', // Mặc định màu trắng
  direction = 'clockwise', // Mặc định quay theo chiều kim đồng hồ
  charSpacing = 8, // Mặc định khoảng cách giữa các ký tự
  fontSize = '1.5rem', // Mặc định kích thước chữ
}) => {
  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      // Điều chỉnh hướng quay dựa trên props direction
      const directionMultiplier = direction === 'clockwise' ? 1 : -1;
      setRotation((prev) => (prev + speed * directionMultiplier) % 360);
    }, 50);

    return () => clearInterval(interval);
  }, [speed, direction]);

  // Tạo mảng các cụm text
  const textGroups = Array.from({ length: count }, (_, i) => i);

  return (
    <div className="relative md:w-full md:h-full w-[300px] h-[300px]">
      {textGroups.map((groupIndex) => {
        // Phân bố đều các cụm text quanh đường tròn
        const groupAngleOffset = (groupIndex * 360) / count;

        return text.split('').map((char, charIndex) => {
          // Tính góc cho từng ký tự trong mỗi cụm
          // Điều chỉnh khoảng cách giữa các ký tự dựa trên độ dài của text
          const charAngleOffset = charIndex * charSpacing;
          const angle = rotation + groupAngleOffset + charAngleOffset;
          const radians = (angle * Math.PI) / 180;

          // Tính toán vị trí dựa trên tâm
          const centerX = earthSize / 2;
          const centerY = earthSize / 2;
          const x = centerX + radius * Math.cos(radians);
          const y = centerY + radius * Math.sin(radians);

          return (
            <div
              key={`${groupIndex}-${charIndex}`}
              className={`absolute`}
              style={{
                left: `${x}px`,
                top: `${y}px`,
                transform: `translate(-50%, -50%) rotate(${angle + 90}deg)`,
                transformOrigin: 'center',
                color: textColor, // Sử dụng màu từ props
                fontSize: fontSize, // Sử dụng kích thước chữ từ props
              }}
            >
              {char}
            </div>
          );
        });
      })}
    </div>
  );
};

export default RotatingText;
